import { getBasicContentSchema } from '@/lib/zy-tiptap-utils';
import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ZyCitationNodeView } from './zycitation-node-view';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        zyCitation: {
            insertZyCitation: () => ReturnType;
        };
    }
}

export const ZyCitationHeadless = Node.create({
    name: 'zyCitation',

    group: 'block',

    isolating: true,

    content: function () {
        return getBasicContentSchema();
    },

    parseHTML() {
        return [
            {
                tag: 'footer > cite',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['footer', HTMLAttributes, ['cite', 0]];
    },

    addCommands() {
        return {
            insertZyCitation:
                () =>
                ({ commands }) => {
                    return commands.insertContent({
                        type: 'zyCitation',
                        content: [
                            {
                                type: 'paragraph',
                                content: [{ type: 'text', text: 'Citation content' }],
                            },
                        ],
                    });
                },
        };
    },
});

export const ZyCitation = ZyCitationHeadless.extend({
    addNodeView() {
        return ReactNodeViewRenderer(ZyCitationNodeView);
    },
});

export default ZyCitation;
